{
  "previous": "Précédent",
  "next": "Suivant",
  "go5back": "Précédent 5",
  "go5next": "Suivant 5",
  "items": "éléments",
  "itemsPerPage": "éléments par page"
}